export const schoolLevels = [
  { value: "preschool", label: "Preschool", sort: 1, alt: "PS" },
  { value: "elementary", label: "Elementary", sort: 2, alt: "ES" },
  { value: "juniorHigh", label: "Junior High", sort: 3, alt: "JHS" },
  { value: "seniorHigh", label: "Senior High", sort: 4, alt: "SHS" },
  { value: "college", label: "College / Higher Ed", sort: 5, alt: "HED" },
];

export const schoolType = [
  { value: "public", label: "Public" },
  { value: "private", label: "Private" },
];

export const classroomCapacity = [
  { value: "0-25", label: "0-25" },
  { value: "25-50", label: "25-50" },
  { value: "50-75", label: "50-75" },
  { value: "75-100", label: "75-100" },
  { value: "100+", label: "100+" },
];

export const schoolYears = [
  { value: "20202021", label: "2020-2021", startYr: "2020", endYr: "2021" },
  { value: "20212022", label: "2021-2022", startYr: "2021", endYr: "2022" },
  { value: "20222023", label: "2022-2023", startYr: "2022", endYr: "2023" },
  { value: "20232024", label: "2023-2024", startYr: "2023", endYr: "2024" },
  { value: "20242025", label: "2024-2025", startYr: "2024", endYr: "2025" },
  { value: "20252026", label: "2025-2026", startYr: "2025", endYr: "2026" },
  { value: "20262027", label: "2026-2027", startYr: "2026", endYr: "2027" },
  { value: "20272028", label: "2027-2028", startYr: "2027", endYr: "2028" },
  { value: "20282029", label: "2028-2029", startYr: "2028", endYr: "2029" },
  { value: "20292030", label: "2029-2030", startYr: "2029", endYr: "2030" },
];

export const syMonths = [
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
  "January",
  "February",
  "March",
  "April",
  "May",
];
